var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 22V16.4389H1.843V20.1667H5.59044V22H0ZM21.4096 22V20.1667H25.157V16.4389H27V22H21.4096ZM3.47099 18.6083V3.36111H5.92833V18.6083H3.47099ZM7.18771 18.6083V3.36111H8.47782V18.6083H7.18771ZM10.9352 18.6083V3.36111H13.4846V18.6083H10.9352ZM14.7747 18.6083V3.36111H18.4915V18.6083H14.7747ZM19.7816 18.6083V3.36111H21.0717V18.6083H19.7816ZM22.3311 18.6083V3.36111H23.4983V18.6083H22.3311ZM0 5.56111V0H5.59044V1.83333H1.843V5.56111H0ZM25.157 5.56111V1.83333H21.4096V0H27V5.56111H25.157Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrIcon);
export default __webpack_public_path__ + "static/media/QR-icon.ef4d96c43c147154f1187da20cc07530.svg";
export { ForwardRef as ReactComponent };